<template>
	<div>
		<b-button class="filter" variant="light" block href="#" v-b-toggle.accordion-filter>
			<span><b-icon-funnel-fill></b-icon-funnel-fill> Filter</span>
			<span class="menu-arrow">
				<b-icon-chevron-right class="float-right chevron-right"></b-icon-chevron-right><b-icon-chevron-down class="float-right chevron-down"></b-icon-chevron-down>
			</span>
		</b-button>
		<b-collapse id="accordion-filter" accordion="accordion-filter" role="tabpanel" class="menu-accordion">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<app-input-combobox-autocomplete :options="incomingDocuments" optionsLabel="documentCode" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Kode Risalah" id="filter-" size="sm" :model.sync="filter.incomingDocumentId" @input="getIncomingDocuments" @focus="getIncomingDocuments" />
					<app-input-combobox-autocomplete v-if="false"  :options="userProfiles" optionsLabel="fullName" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Penerima Disposisi" id="filter-" size="sm" :model.sync="filter.userReceiverId" @input="getUserProfiles" @focus="getUserProfiles" />
					<app-input-textarea v-if="false" id="fieldset-remarks" label-cols-sm="4" label-cols-lg="3" label="Pesan Disposisi" label-for="filter-remarks" size="sm" :model.sync="filter.remarksMultiple" />
					<b-button variant="danger" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
					<b-button variant="primary" size="sm" class="float-right mr-1" @click="getDispositions"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
		</b-collapse>
		<b-row class="mt-3">
			<b-col>
				<b-button variant="warning" v-if="(userRole != null ? userRole.allowUpload : false)" class="float-right ml-2" @click="showPopupUploadData" size="sm"><b-icon-upload class="mr-1"></b-icon-upload> Upload</b-button>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDownload : false)"
					:show="isDownloadDataBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</b-overlay>
				<b-button variant="primary" v-if="(userRole != null ? userRole.allowDownload : false)" class="float-right" href="/files/Disposition/Disposition.xlsx" size="sm"><b-icon-wallet-fill class="mr-1"></b-icon-wallet-fill> Download Template</b-button>
			</b-col>
		 </b-row>
		<b-card class="mt-3">
		<b-row class="mb-3">
			<b-col>
				<span v-if="false">
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/disposition/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</span>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
				<b-overlay
							:show="isExportDataBusy"
							rounded
							opacity="0.6"
							spinner-small
							spinner-variant="primary"
							class="float-right mr-2"
							>
					<b-button variant="warning" @click="exportData" size="sm"><b-icon icon="file-spreadsheet" class="mr-1"></b-icon> Export Data</b-button>
				</b-overlay>
			</b-col>
		</b-row>
		<div class="table-corner">
			<b-table id="my-table" stacked="md" head-variant="light"  :no-local-sorting="true" :items="dispositions" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive>
			<template v-slot:head(actions)>
				<b-button-group class="float-right"  size="sm">
					<b-button @click="isShowFilter = !isShowFilter" size="sm"><b-icon-funnel-fill /></b-button>
					<b-button><b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right" v-model="selectAll"></b-form-checkbox></b-button>
				</b-button-group>
			</template>
			<template #top-row v-if="isShowFilter">
				<b-th></b-th>
				<b-th stacked-heading="Kode Risalah">
					<v-select append-to-body label="documentCode" :options="incomingDocuments" :value="filter.incomingDocumentId" :reduce="item => item.id" v-model="filter.incomingDocumentId" :filterable="true" @input="getDispositionsWithoutLoading" @search="getIncomingDocuments"></v-select>
				</b-th>
				<b-th stacked-heading="Tanggal">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-created-date-from-table" reset-button v-model="createdAtFrom" @input="setBetweenDateFilter('createdAt', createdAtFrom, createdAtTo)" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-created-date-to-table" reset-button v-model="createdAtTo" @input="setBetweenDateFilter('createdAt', createdAtFrom, createdAtTo)" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th stacked-heading="Pengirim Disposisi">
					<b-form-input id="input-sender-name-table" @input="getDispositionsWithoutLoading" v-model="filter['createdBy.fullName']" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Penerima Disposisi">
					<b-form-input id="input-user-receiver-table" @input="getDispositionsWithoutLoading" v-model="filter['userReceiver.fullName']" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Jenis Surat">
					<v-select :components="{OpenIndicator, Deselect}" append-to-body label="name" :options="documentTypes" :value="filter['incomingDocument.documentTypeId']" :reduce="item => item.id" v-model="filter['incomingDocument.documentTypeId']" :filterable="true" @input="getDispositionsWithoutLoading" @search="getDocumentTypes" @open="getDocumentTypes"></v-select>
				</b-th>
				<b-th stacked-heading="Ringkasan surat">
					<b-form-input id="input-remarks-table" @input="getDispositionsWithoutLoading" v-model="filter.incomingDocumentRemarks" size="sm"></b-form-input>
				</b-th>
				<b-th>

				</b-th>
				<b-th stacked-heading="Pesan Disposisi">
					<b-form-input id="input-remarks-table" @input="getDispositionsWithoutLoading" v-model="filter.remarks" size="sm"></b-form-input>
				</b-th>
				<b-th>

				</b-th>
				<b-th stacked-heading="Select All">
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
			</template>
			<template v-slot:cell(incomingDocument)="row">
				{{ row.item.incomingDocument != null ? row.item.incomingDocument.documentCode : "" }}
			</template>
			<template v-slot:cell(incomingDocumentDate)="row">
				{{ row.item.incomingDocument != null ? row.item.incomingDocument.createdAt : "" | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(createdAt)="row">
				{{ row.item != null ? row.item.createdAt : "" | moment("DD-MMM-YYYY") }}
			</template>
			<template v-slot:cell(incomingDocumentSender)="row">
				{{ row.item != null ? row.item.createdByName : "" }}
			</template>
			<template v-slot:cell(documentType)="row">
				{{ row.item.incomingDocument != null ? row.item.incomingDocument.documentTypeName : "" }}
			</template>
			<template v-slot:cell(documentRemarks)="row">
				<span v-if="row.item.incomingDocument != null && (row.item.incomingDocument.remarks != null && row.item.incomingDocument.remarks != '' && row.item.incomingDocument.remarks.length > 15)" v-b-tooltip.hover :title="row.item.incomingDocument != null ? (row.item.incomingDocument.remarks != null && row.item.incomingDocument.remarks != '' ? row.item.incomingDocument.remarks : '') : ''">
					{{ row.item.incomingDocument != null ? (row.item.incomingDocument.remarks != null && row.item.incomingDocument.remarks != "" ? row.item.incomingDocument.remarks.slice(0, 15) + (row.item.incomingDocument.remarks.length > 15 ? "..." : "" )  : "") : "" }}
				</span>
				<span v-else>
					{{ row.item.incomingDocument != null ? (row.item.incomingDocument.remarks != null && row.item.incomingDocument.remarks != "" ? row.item.incomingDocument.remarks : "") : "" }}
				</span>
			</template>
			<template v-slot:cell(remarks)="row">
				<span v-if="row.item != null && (row.item.remarks != null && row.item.remarks != '' && row.item.remarks.length > 15)" v-b-tooltip.hover :title="row.item != null ? (row.item.remarks != null && row.item.remarks != '' ? row.item.remarks : '') : ''">
					{{ row.item != null ? (row.item.remarks != null && row.item.remarks != "" ? row.item.remarks.slice(0, 15) + (row.item.remarks.length > 15 ? "..." : "" ) : "") : "" }}
				</span>
				<span v-else>
					{{ row.item != null ? (row.item.remarks != null && row.item.remarks != "" ? row.item.remarks : "") : "" }}
				</span>
			</template>
			<template v-slot:cell(userReceiver)="row">
				{{ row.item.userReceiver != null ? row.item.userReceiver.fullName : "" }}
			</template>
			<template v-slot:cell(documentAttachment)="row">
				<app-label-fileupload v-if="false" :isEditable="false" label-cols-sm="0" label-cols-lg="0" label="" size="sm" :currentModel="row.item.documentAttachment"  />
				<span v-if="row.item.incomingDocument != null">
					<b-btn-group v-if="row.item.incomingDocument.isFile" @click="showPopupDocument(row.item.incomingDocument)">
						<b-button size="sm" variant="secondary" class="btn-xs">
							{{ row.item.documentAttachmentCount }} Attachment(s)
						</b-button>
						<b-button size="sm" variant="secondary" class="btn-xs">
							<b-icon-paperclip></b-icon-paperclip>
						</b-button>
					</b-btn-group>
				</span>
			</template>
			<template v-slot:cell(actions)="row" >
				<div class="div-actions float-right">
				<span v-if="false">
					<b-button size="sm" v-if="(userRole != null ? userRole.allowUpdate : false)" :to="{path: '/disposition/edit/' + row.item.id }" variant ="success"  class="mr-2 btn-xs">
						<b-icon-pencil></b-icon-pencil>
					</b-button>
				</span>
				<span v-if="row.item.incomingDocument != null">
					<b-button v-b-popover.hover.left="'Buat Disposisi'"  size="sm" v-if="(userRole != null ? userRole.allowRead : true)" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/disposition/createdata/' + row.item.incomingDocument.id }" >
						<b-icon-clipboard-plus></b-icon-clipboard-plus>
					</b-button>
				</span>
				<b-overlay
					v-if="(userRole != null ? userRole.allowDelete : false)"
					:show="busy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<click-confirm>
					<b-button size="sm" v-b-popover.hover.left="'Delete'" variant="danger" @click="deleteData(row.item.id)" class="mr-2 btn-xs">
						<b-icon-trash></b-icon-trash>
					</b-button>
					</click-confirm>
				</b-overlay>
				<b-button size="sm" v-b-popover.hover.left="'Detail'" variant="primary" class="mr-2 mt-md-2 mt-lg-0 btn-xs" :to="{path: '/disposition/detail/' + row.item.id }" >
					<b-icon-eye-fill></b-icon-eye-fill>
				</b-button>
				<b-button size="sm" v-if="(userRole != null ? userRole.allowPrint : false)" variant="light"  @click="printSingleData(row.item.id)" class="mr-2 mt-md-2 mt-lg-0 btn-xs">
					<b-icon-printer-fill></b-icon-printer-fill>
				</b-button>
				<b-form-checkbox v-if="(userRole != null ? false : false)" class="d-inline" :id="'input-is-print-' + (row.index + 1)" @change="toggleIsPrint(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))" ></b-form-checkbox>
				</div>
			</template>
			</b-table>
		</div>
		<b-row>
			<b-col cols="12" md="6" lg="6">
				<span v-if="false">
					<b-button variant="success" v-if="(userRole != null ? userRole.allowCreate : false)" to="/disposition/create" size="sm"><b-icon-pencil class="mr-1"></b-icon-pencil> Create</b-button>
				</span>
				<b-overlay
					v-if="(userRole != null ? userRole.allowPrint : false)"
					:show="isMultiplePrintBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="d-inline-block"
					>
					<b-button variant="primary" v-if="(userRole != null ? userRole.allowPrint : false)" class="ml-2" @click="printData" size="sm"><b-icon-printer-fill class="mr-1"></b-icon-printer-fill> Multiple Print</b-button>
				</b-overlay>
			</b-col>
			<b-col cols="12" md="6" lg="6">
			<b-pagination
				class="float-md-right btn-paging"
				v-model="currentPage"
				:total-rows="(dispositionsPaging != null ? dispositionsPaging.total : 0)"
				:per-page="(dispositionsPaging != null ? dispositionsPaging.perPage : 0)"
				aria-controls="my-table"
			></b-pagination>
			</b-col>
		</b-row>
		</b-card>
		<PopupDownloadDocument :openPopup="isShowPopupDocument" :parent="parent" @resetMethod="resetModalUpload" :allowUpdate="false" />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';
</style>
<script>
import Disposition from '@/models/Disposition/Disposition';
import DispositionList from '@/models/Disposition/DispositionList';
import DispositionFilter from '@/filters/Disposition/DispositionFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputTextarea from '@/components/AppInputTextarea';
import IncomingDocumentFilter from '@/filters/IncomingDocument/IncomingDocumentFilter';
import IncomingDocument from '@/models/IncomingDocument/IncomingDocument';
import UserProfileFilter from '@/filters/UserProfile/UserProfileFilter';
import UserProfile from '@/models/UserProfile/UserProfile';
import DocumentTypeFilter from '@/filters/DocumentType/DocumentTypeFilter';
import DocumentType from '@/models/DocumentType/DocumentType';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import PopupDownloadDocument from '../IncomingDocument/PopupDownloadDocument';

export default {
	components : {Disposition, DispositionList, DispositionFilter, AppInputTextarea,AppInputComboboxAutocomplete,AppInputTextarea,PopupDownload,PopupPDF,Upload,PopupDataEditNotification,PopupDownloadDocument,},
	data() {
		return {
			OpenIndicator: {
                render: createElement => createElement('b-icon-chevron-down',  {class: {'btn-transparent': true}}),
            },
            Deselect: {
                render: createElement => createElement('b-icon-x',  {class: {'btn-transparent': true, 'btn-grey' : true}}),
            },
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"no" : { "class" : "th-number"}}, 
				{"incomingDocument": {}, "class" : "th-incoming-document", "label" : "Kode Risalah", key: 'incomingDocument', sortable: true}, 
				{"createdAt": {}, "class" : "th-incoming-document", "label" : "Tanggal", key: 'createdAt', sortable: true}, 
				{"incomingDocumentSender": {}, "class" : "th-incoming-document", "label" : "Pengirim Disposisi", key: 'incomingDocumentSender', sortable: true}, 
				{"userReceiver": {}, "class" : "th-user-receiver", "label" : "Penerima Disposisi", key: 'userReceiver', sortable: true}, 
				{"documentType": {}, "class" : "th-user-receiver", "label" : "Jenis Surat", key: 'documentType', sortable: true}, 
				{"documentRemarks": {}, "class" : "th-user-receiver", "label" : "Ringkasan Surat", key: 'documentRemarks', sortable: true}, 
				{"documentAttachment": {}, "class" : "th-document-attachment", "label" : "File Document", key: 'documentAttachment', sortable: false}, 
				{"remarks": {}, "class" : "th-remarks", "label" : "Pesan Disposisi", key: 'remarks', sortable: true}, 
				{"dispositionStatus": {}, "class" : "th-disposition-status", "label" : "Status", key: 'dispositionStatusUser', sortable: false}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			dispositions: [],
			dispositionsPaging: {},
			incomingDocuments : [],
			userProfiles : [],
			parent:{},
			isSendEmailBusy: false,
			isShowPopupDocument: false,
			isExportDataBusy: false,

			createdAtFrom: "",
			createdAtTo: "",
			documentTypes: [],
		}
	},
	methods : {
		showPopupDocument(parent) {
			this.parent=parent;
			this.isShowPopupDocument = true;
		},
		getDispositions : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null && this.sortBy != "") {
				this.sortingBy[this.sortBy] = this.sortDesc;
			} else {
				this.sortingBy["createdAt"] = true;
			}
			Disposition.getList(this, this.filter, this.sortingBy, this.currentPage, this.pageSizeOptions, 'incomingDocument,userReceiver,incomingDocumentAttachmentDetail')
			.then(result => {
				if (result != null) {
					this.dispositions = result.data
					this.dispositionsPaging = result.pagination
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getDispositionsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null && this.sortBy != "") {
				this.sortingBy[this.sortBy] = this.sortDesc;
			} else {
				this.sortingBy["createdAt"] = true;
			}
			Disposition.getList(this, this.filter, this.sortingBy, this.currentPage, this.pageSizeOptions, 'incomingDocument,userReceiver,incomingDocumentAttachmentDetail')
			.then(result => {
				if (result != null) {
					this.dispositions = result.data
					this.dispositionsPaging = result.pagination
				}
			})
			.catch(error => {});
		},
		getIncomingDocuments : async function(input) {
			let filter = new IncomingDocumentFilter();
			if (input != undefined) {
				filter.documentCode = input;
			}
			IncomingDocument.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.incomingDocuments = result.data
				}
			})
			.catch(error => {});
		},
		getUserProfiles : async function(input) {
			let filter = new UserProfileFilter();
			if (input != undefined) {
				filter.fullName = input;
			}
			UserProfile.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userProfiles = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentTypes : async function(input) {
			let filter = new DocumentTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentTypes = result.data
				}
			})
			.catch(error => {});
		},
		resetFilter() {
			this.filter = new DispositionFilter();
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getDispositions();
			this.isShowPopupDocument = false;
		},
		toggleIsPrint(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				Disposition.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
					this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			Disposition.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			if (this.sortBy != null) {
					this.sortingBy[this.sortBy] = this.sortDesc;
			}
			this.isDownloadDataBusy = true;
			Disposition.downloadData(this, this.filter, this.sortingBy).then(result => {
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			}).catch(error => { this.isDownloadDataBusy = false; })
		},
		deleteData(id) {
			Disposition.deleteData(this, id).then(result => {
				if (result)
				{
					this.getDispositions();
				}
			})
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},
		exportData() {
			this.sortingBy = Array();
			if (this.sortBy != null && this.sortBy != "") {
				this.sortingBy[this.sortBy] = this.sortDesc;
			} else {
				this.sortingBy["createdAt"] = true;
			}
			this.isExportDataBusy = true;
			Disposition.exportData(this, this.filter, this.sortingBy, this.currentPage, this.pageSizeOptions, 'incomingDocument,userReceiver,incomingDocumentAttachmentDetail')
			.then(result => {
				if (result != null) {
					saveAs(result.data, "disposisi.xlsx");
				}
				this.isExportDataBusy = false;
			})
			.catch(error => {
				this.isExportDataBusy = false;
			});
		},
		setBetweenDateFilter(filterName, from, to) {
			this.filter[filterName + "From"] = from;
			this.filter[filterName + "To"] = to;
			this.getDispositionsWithoutLoading();
		},
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new DispositionFilter();
		this.getIncomingDocuments()
		this.getUserProfiles()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Disposition"
		];
		this.getDispositions();
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
		});
	},
	watch: {
		sortBy: {
			handler: function() {
				this.getDispositions();
			}
		},
		sortDesc: {
			handler: function() {
				this.getDispositions();
			}
		},
		currentPage: {
			handler: function() {
				this.getDispositions();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getDispositions();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				Disposition.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "dispositionindex") {
					this.getDispositionsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "disposition").first();
		}
	},
	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
